import React from "react";
import { Box, Typography, TextField, Button, Container } from "@mui/material";

export default function Footer() {
  return (
    <Box sx={{}}>
      {/* Main Footer Section */}
      <Box
        sx={{
          background: "#1a1a1a",
          color: "#fff",
          py: 6,
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* Heading */}
          <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
            Stay up to date with our news, ideas and updates
          </Typography>

          {/* Subscription Form */}
          <Box
            component="form"
            sx={{
              display: "flex",
              gap: 1,
              mt: 3,
              width: "100%",
              maxWidth: "500px",
            }}
          >
            <TextField
              fullWidth
              placeholder="Your email address"
              variant="outlined"
              sx={{
                background: "#fff",
                borderRadius: "6px",
              }}
            />
            <Button
              variant="contained"
              sx={{
                px: 3,
                background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: "6px",
                "&:hover": {
                  background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                },
              }}
            >
              Subscribe
            </Button>
          </Box>

          {/* Submitting text (optional) */}
          <Typography variant="caption" sx={{ mt: 2, color: "#a1c97b" }}>
            Submitting...
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
